import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useNotifications } from '../../components/appointments/notifications';

const GoogleAuthMiddleware = () => {
  const { showSuccess, showError, NotificationComponent } = useNotifications();
  const navigate = useNavigate();
  const location = useLocation();

  const hasRedirected = useRef(false);
useEffect(() => {
  if (hasRedirected.current) return; // ✅ prevents re-running
  hasRedirected.current = true;

  const urlParams = new URLSearchParams(location.search);
  const token = urlParams.get('token');
  const userId = urlParams.get('userId');
  const authStatus = urlParams.get('auth_status');
  const message = urlParams.get('message');

  if (token) {
    localStorage.setItem('token', token);
    if (userId) localStorage.setItem('userId', userId);
  }

  if ((authStatus === 'success' || authStatus === 'error') && message) {
    if (authStatus === 'success') {
      showSuccess(decodeURIComponent(message));
    } else {
      showError(decodeURIComponent(message));
    }
  }

  const goToAppointments = () => navigate('/appointments', { replace: true });

  if (token && userId) {
    fetch('/api/ui/appointment/gCal/userDetails', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ userId })
    })
      .then(res => res.json())
      .then(data => {
        if (data && data.user) {
          if (data.user.name) localStorage.setItem('userName', data.user.name);
          // Prefer google_picture if available, else fallback to profileImageUrl
          if (data.user.google_picture) {
            localStorage.setItem('profileImageUrl', data.user.google_picture);
          } else if (data.user.profileImageUrl) {
            localStorage.setItem('profileImageUrl', data.user.profileImageUrl);
          }
          if (data.user.email) localStorage.setItem('userEmail', data.user.email);
          if (data.user.phone) localStorage.setItem('phone', data.user.phone);
        }
      })
      .catch(err => {
        console.error('Failed to fetch user profile:', err);
      })
      .finally(goToAppointments); // ✅ navigate only after fetch
  } else {
    goToAppointments(); // ✅ still navigate even without token
  }
}, [location, navigate, showSuccess, showError]);


  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      <NotificationComponent />
      <div className="flex flex-col items-center justify-center">
        <div className="w-16 h-16 border-4 border-gray-300 border-t-black rounded-full animate-spin mb-4"></div>
        <div className="text-lg text-gray-700 font-semibold">Processing Google authentication...</div>
      </div>
    </div>
  );
};

export default GoogleAuthMiddleware;
